
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"16","height":"7","viewBox":"0 0 16 7","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12.5 7C10.693 7 9.26 5.951 8 4.845 6.74 5.951 5.307 7 3.5 7 1.57 7 0 5.43 0 3.5S1.57 0 3.5 0C5.307 0 6.74 1.049 8 2.155 9.26 1.049 10.693 0 12.5 0 14.43 0 16 1.57 16 3.5S14.43 7 12.5 7zM9.501 3.5c.973.838 1.936 1.5 2.999 1.5.827 0 1.5-.673 1.5-1.5S13.327 2 12.5 2c-1.063 0-2.026.662-2.999 1.5zM3.5 2C2.673 2 2 2.673 2 3.5S2.673 5 3.5 5c1.063 0 2.026-.662 2.999-1.5C5.526 2.662 4.563 2 3.5 2z","fill":"#FFF","opacity":".5"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      